module.exports = __webpack_public_path__ + "img/gestya.6d10eb9f.jpg";